export default __webpack_public_path__ + "static/media/VanHautenStBirdView.72d6fab9.png";